var map = {
	"./basic-text/options.json": 326,
	"./cta-block/options.json": 837,
	"./featured-posts/options.json": 727,
	"./hero/options.json": 387,
	"./icon-row/options.json": 739,
	"./single-image/options.json": 435,
	"./text-image/options.json": 644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 330;